if (!customElements.get('motion-element')) {
  customElements.define('motion-element', class extends HTMLElement {
    connectedCallback() {
      Object.assign(this.style, {
        visibility: 'visible',
        transform: 'none',
        opacity: '1'
      });
      this.dataset.initialized = '';
    }
  });
}
